<template>
  <div class="toast-stack" role="status" aria-live="polite">
    <transition-group name="toast" tag="div">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="toast"
        :class="'toast--' + t.type"
      >
        <span class="toast__text">{{ t.message }}</span>
        <button class="toast__close" aria-label="Закрыть" @click="dismiss(t.id)">×</button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastBus } from '../toast';

export default {
  name: 'Toast',
  data() {
    return {
      toasts: [],
      timers: {},
    };
  },
  created() {
    this._onToast = (t) => this.add(t);
    toastBus.$on('toast', this._onToast);
  },
  beforeDestroy() {
    toastBus.$off('toast', this._onToast);
    Object.values(this.timers).forEach(clearTimeout);
  },
  methods: {
    add(t) {
      // не плодить одинаковые сообщения подряд
      if (this.toasts.some((x) => x.message === t.message && x.type === t.type)) return;
      this.toasts.push(t);
      if (t.timeout > 0) {
        this.timers[t.id] = setTimeout(() => this.dismiss(t.id), t.timeout);
      }
    },
    dismiss(id) {
      this.toasts = this.toasts.filter((x) => x.id !== id);
      if (this.timers[id]) {
        clearTimeout(this.timers[id]);
        delete this.timers[id];
      }
    },
  },
};
</script>

<style scoped>
.toast-stack {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: calc(100% - 32px);
  max-width: 420px;
  pointer-events: none;
}

.toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 15px;
  line-height: 1.4;
  color: #fff;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
}

.toast--error {
  background: #c62f2f;
}

.toast--info {
  background: #0b89ac;
}

.toast--success {
  background: #2e7d54;
}

.toast__text {
  flex: 1;
}

.toast__close {
  background: none;
  border: none;
  color: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  opacity: 0.85;
}

.toast__close:hover {
  opacity: 1;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
  .toast-enter-active,
  .toast-leave-active {
    transition: none;
  }
}
</style>
